import * as React from 'react';

export interface IExperienceProps {
}

export function Experience(props: IExperienceProps) {
    return (
        <section className="experience-section">
            <div className="experience-container">
                <h2 className="experience-title">12 Years Experience</h2>
                <div className="experience-timeline">
                    <div className="experience-block clearfix">
                        <div className="meta">
                            <span className="year">2021 - Current</span>
                            <span className="company">Tata Consultancy Services</span>
                        </div>
                        <div className="content">
                            <h5>Full Stack Java Developer</h5>
                            <p>As a Java full stack developer,I'm responsible for designing, developing, and maintaining both the front-end and back-end components of our applications. This involves working with Java technologies such as Spring Framework for back-end development, and utilizing HTML, CSS, and JavaScript framework React for the front-end. I collaborate closely with cross-functional teams including designers, product managers, and other developers to ensure that our applications meet both user requirements and technical standards.</p>
                        </div>
                        <div className="icon">
                            <img src='./assets/images/icons-java-48.png' alt='java'/>
                        </div>
                    </div>
                    <div className="experience-block clearfix">
                        <div className="meta">
                            <span className="year">2017 - 2021</span>
                            <span className="company">NeST Digital</span>
                        </div>
                        <div className="content">
                            <h5>Full Stack Java Developer</h5>
                            <p>Contributed as a Java backend developer in a dynamic digital environment, crafting robust and scalable solutions to drive seamless functionality. Collaborated with cross-functional teams to design and implement efficient backend systems, leveraging Java technologies. </p>
                        </div>
                        <div className="icon">
                        <img src='./assets/images/icons-java-48.png' alt='java'/>
                        </div>
                    </div>
                    <div className="experience-block clearfix">
                        <div className="meta">
                            <span className="year">2015 - 2016</span>
                            <span className="company">Travancore Analytics</span>
                        </div>
                        <div className="content">
                            <h5>Mobile App Developer</h5>
                            <p>Leveraged expertise in Java & Android to create user-friendly interfaces and enhance digital experiences. Collaborated within a dynamic team environment to deliver high-quality solutions for a diverse range of projects.</p>
                        </div>
                        <div className="icon">
                        <img src='./assets/images/icons-android-48.png' alt='android'/>
                        </div>
                    </div>
                    <div className="experience-block clearfix">
                        <div className="meta">
                            <span className="year">2013 - 2015</span>
                            <span className="company">FeatherSoft</span>
                        </div>
                        <div className="content">
                            <h5>Mobile App Developer</h5>
                            <p>Developed cutting-edge Android applications to enhance user experiences and streamline digital interactions in a dynamic corporate environment.</p>
                        </div>
                        <div className="icon">
                        <img src='./assets/images/icons-android-48.png' alt='android'/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
